export interface graphData {
		nodes: any[];
		edges: any[];
}

export const initialGraphData: graphData = {
	nodes: [],
	edges: []
}
